import loadjs from 'loadjs'
import loginClient from '@/services/clients/login'

let isMessengerOpen = false

export function openZendesk (store) {
  runZendeskCommand('open', store)
}

export function toggleZendesk (store) {
  runZendeskCommand('toggle', store)
}

function runZendeskCommand (command, store) {
  loadZendesk(store)
    .then(() => {
      if (command === 'toggle') {
        window.zE('messenger', isMessengerOpen ? 'close' : 'open')
      } else {
        window.zE('messenger', command)
      }
    })
    .catch(e => {
      console.warn('Failed to load zendesk', e)
      throw e
    })
}

function loadZendesk (store) {
  if (loadjs.isDefined('zendesk')) return Promise.resolve()
  return loadjs([
    'https://static.zdassets.com/ekr/snippet.js?key=f212f022-ffd0-4615-b93e-245823209913',
  ], 'zendesk', {
    numRetries: 3,
    returnPromise: true,
    before: function (path, scriptEl) {
      scriptEl.id = 'ze-snippet'
    }
  })
    .then(() => initZendesk(store))
}

function initZendesk (store) {
  return new Promise(resolve => {
    pollAndInitZendesk(store, resolve)
  })
}

function pollAndInitZendesk (store, resolve) {
  if (window.zE) {
    // Hide the default launcher button because this app uses a custom launcher.
    window.zE('messenger', 'hide')
    window.zE('messenger', 'loginUser', callback => {
      loginClient.post('zendesk/messaging/jwt/console')
        .then(response => callback(response.data.jwt))
        .catch(error => {
          // If JWT retrieval fails, continue as anonymous visitor.
          console.warn('Failed to login Zendesk messenger user', error)
          callback()
        })
    })
    window.zE('messenger:on', 'open', () => {
      isMessengerOpen = true
      window.zE('messenger', 'show')
    })
    window.zE('messenger:on', 'close', () => {
      isMessengerOpen = false
      window.zE('messenger', 'hide')
    })
    resolve()
  } else {
    setTimeout(() => pollAndInitZendesk(store, resolve), 20)
  }
}
